module.exports = __webpack_public_path__ + "img/clock.142afb71.svg";